<script setup lang="ts">
    import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3 sm:grid-cols-1">
        <InputRow
            :form="form"
            name="name"
            label="kube.form.name"
        >
            <Input
                id="name"
                v-model="form.name"
                :placeholder="$t('kube.form.name')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="number"
            label="kube.form.number"
        >
            <Input
                id="number"
                v-model="form.number"
                :placeholder="$t('kube.form.number')"
                type="number"
            />
        </InputRow>
    </div>
</template>
